import type { FC, ReactNode } from 'react';

/**
 * 外部リンクコンポーネント
 */
export const ExternalLink: FC<{
  href: string;
  className: string;
  onClick?: () => void;
  openInNewTab?: boolean;
  children: ReactNode;
}> = ({ href, className, onClick, openInNewTab, children }) => {
  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      {children}
    </a>
  );
};
